import { Component, Shark, Utils } from "shark-mvc";
import $ from "jquery";
import moment from "moment";

import templateContent from "./replace-quotation-accept-document-actions.html";

import followUpManager from "../../_shark_jaws/managers/followUpManager";
import { constructionSiteManager } from "../../_shark_jaws/managers/constructionSiteManager";
import disableActionButtonComponent from "../disableActionButton/disableActionButtonComponen";
import { documentManager } from "../../_shark_jaws/managers/documentManager";
// import { folderManager } from "../../_shark_jaws/managers/folderManager";
import waitBoxComponent from "../../_shark_components/waitBox/waitBoxComponent";
import { quotationManager } from "../../_shark_jaws/managers/quotationManager";

class ReplaceQuotationAcceptDocumentComponent extends Component {
	constructor() {
		super("replaceQuotationAcceptDocumentComponent");

		this.addTemplate("", templateContent);
	}

	afterRender () {
		if (this.get("open")) {
			$("#replaceQuotationAcceptDocumentModal").modal("show");
		}
	}
	
	replaceQuotationAcceptDocumentModalCancelBtn_clickHandler () {
		this.close();
	}

	replaceAcceptDocumentBtn_clickHandler (event, data) {
		const currQuotation = Utils.safp(Shark.get("quotationList"), "guid", data.guid);
		Shark.set({currQuotation});
		this.open()
	}
	
	// replaceQuotationAcceptDocumentModalConfirmBtn_clickHandler () {
	// 	if (this.isFormValid()) {
	// 		if (confirm("Sei sicuro di voler confermare la chiusura del cantiere?\nSe prosegui non potrai annullare l'operazione!")) {
	// 			this.saveDocumentAndConstructionSite();
	// 		}
	// 	}
	// }
	
	// replaceQuotationAcceptDocumentModalConfirmTeamCloseDocumentBtn_clickHandler () {
	// 	if (this.isFormValid()) {
	// 		this.saveDocumentAndConstructionSite();
	// 	}
	// }
	
	replaceQuotationAcceptDocumentSendAcceptDocumentBtn_clickHandler () {
		document.querySelector("#uploadAcceptDocument").click();
	}
	
	close () {
		$(`#replaceQuotationAcceptDocumentModal`).modal("hide");
		
		const body = document.querySelector("body");
		body.classList.remove("wait-box-open");
		body.classList.remove("modal-open");
		body.style.removeProperty("padding-right");

		this.set("open", false);
	}
	
	init () {
		this.addComponents([disableActionButtonComponent, waitBoxComponent]);

		const currUploadingDocument = Shark.getInstance("__smart__", {
			document: null,
			fileName: ""
		});
	
		Shark.set({currUploadingDocument});
	
		this.set({
			open: false,
			// __showEditOptions: false,
			// __showWaitingConstructionSiteCardActions: false,
		});
	}

	// //Dave: Bisogna inserire della validazione
	// isFormValid (mode = "") {
	// 	return true;
	// }
	
	//Dave.Warn: dato che questa roba è uguale nella conferma del preventivo nel quotationActionsComponent
	replaceQuotationAcceptDocumentModalConfirmAndSaveBtn_clickHandler (event) {
		const currUploadingDocument = Shark.get("currUploadingDocument");

		if (!currUploadingDocument.document) {
			setTimeout(() => {
				disableActionButtonComponent.resetStatus(event.target);
			}, 250);
			return;
		}

		waitBoxComponent.show();

		const currQuotation = Shark.get("currQuotation");
		// const quotationAttachmentsBox = document.querySelector("#quotationAttachmentsBox");
		
		if (currQuotation) {
			//Dave: dai, gestiamo la possibilità di mantenere il vecchio.
			// = currUploadingDocument.document;
			currQuotation.set("extraData.confirmData.sentFileIsTemporary", false);

			if (currQuotation.extraData.confirmData.builtPDFURL && currQuotation.extraData.confirmData.builtPDFURL !== "") {
				currQuotation.extraData.confirmData.previousBuiltPDFURL = currQuotation.extraData.confirmData.builtPDFURL;
				currQuotation.extraData.confirmData.builtPDFURL = "";
			}

			currQuotation.extraData.confirmData.pictures = [{
				label: currUploadingDocument.document.name + "." + currUploadingDocument.document.fileType,
				size: currUploadingDocument.document.fileSize,
				thumbURL: currUploadingDocument.document.thumbnailURL || (currUploadingDocument.document.fileURL.substr(-3) === "pdf" ? pdfIcon : docIcon),
				type: currUploadingDocument.document.fileType.toLowerCase(),
				url: currUploadingDocument.document.fileURL
			}];
			console.log({currQuotation});
			// return;
			// let jpegAttachments = [];
			// currQuotation.extraData.confirmData.pictures.forEach(item => {
			// 	if (item.type === "jpg" || item.type === "jpeg") {
			// 		jpegAttachments.push(item);
			// 	}
			// });

			// //Dave: valutare se fare il pdf solo in caso di length > 0
			// if (jpegAttachments.length > 0 && jpegAttachments.length === currQuotation.extraData.confirmData.pictures.length) {
			// 	let htmlForPdf = `<html><head>
			// 	<style>
			// 		.with-page-break {
			// 			margin-bottom: 1em
			// 			page-break-before: always;
			// 			page-break-after: always;
			// 		}
			// 	</style>
			// 	<head><body>`;

			// 	jpegAttachments.forEach(item => {
			// 		htmlForPdf += `<div class="with-page-break"><img src="${Shark.get("__cdnURL")}/${item.url}" style="width: 100%"></div>`;
			// 	})

			// 	htmlForPdf += "</body></html>";

			// 	documentManager.htmlToPdf({
			// 		destFolder: "quotation-attachments",
			// 		htmlCode: htmlForPdf,
			// 		saveName: "Preventivo-" + currQuotation.code.replace(" ", "_") + "-conferma.pdf",
			// 	})
			// 	.then(savePDFResponse => {
			// 		console.log({savePDFResponse});

			// 		currQuotation.extraData.confirmData.builtPDFURL = savePDFResponse.data[0];

			// 		quotationActionsComponent.saveConfirmedQuotation();
			// 	});
			// }
			// else {
				this.saveConfirmedQuotation();
			// }
		}
	}

	saveConfirmedQuotation () {
		const [currQuotation, currUser] = Shark.get(["currQuotation", "currUser"]);

		if (currQuotation) {
			quotationManager.save(currQuotation)
			.then(jsonResponse => {
				const newFollowUp = Shark.getInstance("ClientFollowUp", {
					body: `Sostituito il documento di accettazione per il Preventivo <q>${currQuotation.code}</q>.`,
					clientGuid: currQuotation.clientGuid,
					referenceGuid: currQuotation.guid,
					referenceType: "quotation",
					status: 3,
					type: "system"
				});
		
				followUpManager.save(newFollowUp)
				.then(sharkResponse => {
					this.close();
					waitBoxComponent.hide();
					Shark.render();
				});
			});
		}
	}

	open () {
		const currUploadingDocument = Shark.get("currUploadingDocument");
		currUploadingDocument.document = null;

		this.set({
			__nextSaveName: Shark.__generateGUID(),
		});
		Shark.render();
		$(`#replaceQuotationAcceptDocumentModal`).modal("show");
		this.set("open", true);
	}

	uploadAcceptDocument_changeHandler (event) {
		if (event.target.files.length === 0) {
			return;
		}
	
		waitBoxComponent.show();

		documentManager.upload(event.target)
		.then(uploadDocumentResponse => {
			const uploadedDocument = uploadDocumentResponse.data.documents[0];
			const currUploadingDocument = Shark.get("currUploadingDocument");

			currUploadingDocument.set({
				document: uploadedDocument,
				fileName: uploadedDocument.name + "." + uploadedDocument.fileType,
			});
		// 	// const currConstructionSite = Shark.get("currConstructionSite");
		// 	// const currConstructionSiteTeamCloseDocument = Shark.get("currConstructionSiteTeamCloseDocument");
	
		// 	// folderManager.getByReference(currConstructionSite.siteInfoSheetGuid, "siteInfoSheet")
		// 	// .then(getSISFolderResponse => {
		// 	// 	console.log({getSISFolderResponse});
		// 	// 	let projectFolderGuid = "";
	
		// 	// 	if (getSISFolderResponse.data.length > 0) {
		// 	// 		const projectFolder = Utils.safp(getSISFolderResponse.data, "type", "siteInfoSheet");
		// 	// 		projectFolderGuid = projectFolder.guid;
		// 	// 	}

		// 	// 	uploadedDocument.set({
		// 	// 		["extraData.lotId"]: currConstructionSite.__lotId,
		// 	// 		folderGuid: projectFolderGuid,
		// 	// 		role: "fiscalClosingDocument",
		// 	// 		source: "constructionSite"
		// 	// 	});

		// 	// 	if (currConstructionSiteTeamCloseDocument) {
		// 	// 		currConstructionSiteTeamCloseDocument.set({
		// 	// 			document: uploadedDocument,
		// 	// 			fileName: uploadedDocument.name + "." + uploadedDocument.fileType,
		// 	// 		});
		// 	// 	}
		// 	// 	console.log({currConstructionSite, currConstructionSiteTeamCloseDocument, uploadedDocument});
			waitBoxComponent.hide();
		});
	}
}

const replaceQuotationAcceptDocumentComponent = new ReplaceQuotationAcceptDocumentComponent();

Shark.registerComponent(replaceQuotationAcceptDocumentComponent);

export default replaceQuotationAcceptDocumentComponent;
